const SPORT_TYPES = Object.freeze({
  FOOTBALL: 'football',
  UNIVERSAL: 'universal',
  RUGBY: 'rugby',
  TOUCH_RUGBY: 'touchRugby',
  CRICKET: 'cricket',
  BOXING: 'boxing',
  GOLF: 'golf',
  AMERICAN_FOOTBALL: 'american football',
  ARCHERY: 'archery',
  ATHLETICS: 'athletics',
  BMX: 'bmx',
  BADMINTON: 'badminton',
  BASEBALL: 'baseball',
  BASKETBALL: 'basketball',
  BOWLING: 'bowling',
  BOWLS: 'bowls',
  CHEERLEADING: 'cheerleading',
  CURLING: 'curling',
  CYCLING: 'cycling',
  DANCING: 'dancing',
  DARTS: 'darts',
  DIVING: 'diving',
  DODGEBALL: 'dodgeball',
  FENCING: 'fencing',
  FISHING: 'fishing',
  GAELIC_FOOTBALL: 'gaelic gootball',
  HANDBALL: 'handball',
  HOCKEY: 'hockey',
  HORSE_RIDING: 'horse riding',
  HURLING: 'hurling',
  ICE_HOCKEY: 'ice hockey',
  ICE_SKATING: 'ice skating',
  KAYAKING_OR_CANOEING: 'kayaking or canoeing',
  KORFBALL: 'korfball',
  LACROSSE: 'lacrosse',
  MMA: 'mma',
  MOUNT_BIKING: 'mountain biking',
  NETBALL: 'netball',
  POLO: 'polo',
  QUIDITCH: 'quiditch',
  ROCK_CLIMBING: 'rock climbing',
  ROUNDERS: 'rounders',
  ROWING: 'rowing',
  RUNNING: 'running',
  SAILING: 'sailing',
  SHOOTING: 'shooting',
  SKATEBOARDING: 'skateboarding',
  SKIING: 'skiing',
  SKIPPING: 'skipping',
  SKYDIVING: 'skydiving',
  SLEDGING: 'sledging',
  SNOOKER_OR_POOL: 'snooker or pool',
  SNOOKER: 'snooker',
  POOL: 'pool',
  SNOWBOARDING: 'snowboarding',
  SQUASH: 'squash',
  SURFING: 'surfing',
  SWIMMING: 'swimming',
  TABLE_TENNIS: 'table tennis',
  TENNIS: 'tennis',
  ULTIMATE_FRISBEE: 'ultimate frisbee',
  UNDERWATER_HOCKEY: 'underwater hockey',
  VOLLEYBALL: 'volleyball',
  WATER_POLO: 'water polo',
  WATER_SPORTS: 'water sports',
  WEIGHTLIFTING: 'weightlifting',
  WRESTLING: 'wrestling',
});

export default SPORT_TYPES;
